import React, { useState } from "react";
import ConfirmModal from "../../../../modals/ConfirmModal";
import { FaRegEdit } from "react-icons/fa";
import { FaTrashAlt } from "react-icons/fa";

const AddressCardComponent = ({ company, addresses, type, toggleView, onDelete }) => {
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [addressId, setAddressId] = React.useState(null);
    const [addressType, setAddressType] = React.useState(null);

    const handleAddMore = () => {
        toggleView(type, 'form')
    }
    const handleEditAddress = (address) => {
        toggleView(type, 'form', address);
    }
    const handleDeleteAddress = (id) => {
        setAddressId(id)
        setAddressType(type)
        setShowConfirmModal(true);
    }
    const handleCancel = () => {
        setShowConfirmModal(false);
    }

    return (
        <>
            <div className="col-12 col-lg-12 mb-4">
                <div className="card">
                    <div className="card-header">
                        <div className="card-title">
                            <div className="row align-items-end">
                                <div className="col">
                                    <h2 className="header-title">
                                        {company}
                                    </h2>
                                </div>
                                <div className="col-auto">
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={handleAddMore}
                                    >
                                        Add More
                                    </button >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            {addresses.map((address) => (
                                <div key={address.id} className="col-12 col-md-6 col-lg-4 mb-3">
                                    <div className="toast show w-100" role="alert" aria-live="assertive" aria-atomic="true">
                                        <div className="toast-header justify-content-end">
                                            <button
                                                className="border border-secondary-subtle rounded text-white bg-primary"
                                                onClick={() => handleEditAddress(address)}
                                            >
                                                <FaRegEdit size={18} />
                                            </button>
                                            {' | '}
                                            <button
                                                className="border border-secondary-subtle rounded text-white bg-danger"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleDeleteAddress(address.id);
                                                }}
                                            >
                                                <FaTrashAlt size={14} />
                                            </button>
                                        </div>
                                        <div className="toast-body">
                                            <div className="row justify-content-between">
                                                <div className="col-auto"><small><b>Address:</b></small></div>
                                                <div className="col-auto"><small>{address.address}</small></div>
                                            </div>
                                            <div className="row justify-content-between">
                                                <div className="col-auto"><small><b>City:</b></small></div>
                                                <div className="col-auto"><small>{address.city}</small></div>
                                            </div>
                                            <div className="row justify-content-between">
                                                <div className="col-auto"><small><b>State:</b></small></div>
                                                <div className="col-auto"><small>{address.state}</small></div>
                                            </div>
                                            <div className="row justify-content-between">
                                                <div className="col-auto"><small><b>Country:</b></small></div>
                                                <div className="col-auto"><small>{address.country}</small></div>
                                            </div>
                                            <div className="row justify-content-between">
                                                <div className="col-auto"><small><b>Zipcode:</b></small></div>
                                                <div className="col-auto"><small>{address.zipcode}</small></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {showConfirmModal && (
                <ConfirmModal show={showConfirmModal} onCancel={handleCancel} onConfirm={onDelete} id={addressId} type={addressType} heading='Delete Address'
                    content='Are you sure you want to delete this address?' />
            )
            }
        </>
    )
}
export default AddressCardComponent;